import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmbroideredMackyComponent } from './embroidered-workwear-mackay.component';

const routes: Routes = [
  { path: '', component: EmbroideredMackyComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmbroideredMackyRoutingModule { }
